import { ERROR_DISPLAY_TYPES, type ErrorDisplayType } from "./error.types";

export const apiErrorToTranslationKey: Record<
  string,
  { key: string; types: ErrorDisplayType[] }
> = {
  role_name_already_in_use_for_this_organization: {
    key: "role_name_unique_error",
    types: [ERROR_DISPLAY_TYPES.FORM, ERROR_DISPLAY_TYPES.TOAST],
  },
  entity_has_been_modified_by_another_user: {
    key: "entity_concurrent_modification_message",
    types: [ERROR_DISPLAY_TYPES.TOAST],
  },
  company_group_name_already_used_found: {
    key: "group_form_name_already_used",
    types: [ERROR_DISPLAY_TYPES.FORM, ERROR_DISPLAY_TYPES.TOAST],
  },
  user_group_name_already_in_use: {
    key: "group_form_name_already_used",
    types: [ERROR_DISPLAY_TYPES.FORM, ERROR_DISPLAY_TYPES.TOAST],
  },
  access_control_already_exists: {
    key: "create_access_control_already_set",
    types: [ERROR_DISPLAY_TYPES.ALERT],
  },
  company_group_in_use_cannot_deleted: {
    key: "company_group_in_use_cannot_deleted",
    types: [ERROR_DISPLAY_TYPES.TOAST],
  },
  user_group_in_use_cannot_be_deleted: {
    key: "user_group_in_use_cannot_be_deleted",
    types: [ERROR_DISPLAY_TYPES.TOAST],
  },
  role_in_use_cannot_be_deleted: {
    key: "role_in_use_cannot_be_deleted",
    types: [ERROR_DISPLAY_TYPES.TOAST],
  },
};
export const DEFAULT_ERROR_TRANSLATION_KEY = "unknown_error_occurred";
export const DEFAULT_ERROR_TYPES: ErrorDisplayType[] = [
  ERROR_DISPLAY_TYPES.TOAST,
];
